function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _objectSpread({
        viewBox: "0 0 152 152"
    }, props, {
        children: /*#__PURE__*/ _jsx("g", {
            id: "Layer_2",
            "data-name": "Layer 2",
            children: /*#__PURE__*/ _jsx("g", {
                id: "Color",
                children: /*#__PURE__*/ _jsxs("g", {
                    id: "_02.YouTube",
                    "data-name": "02.YouTube",
                    children: [
                        /*#__PURE__*/ _jsx("circle", {
                            id: "Background",
                            cx: "76",
                            cy: "76",
                            r: "76"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            id: "Icon",
                            d: "m100.87 47.41h-49.74a15.13 15.13 0 0 0 -15.13 15.14v26.9a15.13 15.13 0 0 0 15.13 15.14h49.74a15.13 15.13 0 0 0 15.13-15.14v-26.9a15.13 15.13 0 0 0 -15.13-15.14zm-35.41 40.85v-24.52l21.08 12.26z",
                            fill: "#27262c"
                        })
                    ]
                })
            })
        })
    }));
};
export default Icon;
